import { MouseEvent } from "react";
import { ToggleButtonGroup, ToggleButton, Tooltip } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import GridViewIcon from "@mui/icons-material/GridView";

export type FileExplorerViewMode = "list" | "icons";

interface ViewToggleProps {
  value: FileExplorerViewMode;
  onChange: (value: FileExplorerViewMode) => void;
}

const ViewToggle = ({ value, onChange }: ViewToggleProps) => {
  const handleChange = (
    _event: MouseEvent<HTMLElement>,
    newValue: FileExplorerViewMode | null,
  ) => {
    if (newValue !== null) onChange(newValue);
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      sx={{
        "& .MuiToggleButton-root": {
          px: 1.5,
          py: 0.5,
          border: "1px solid",
          borderColor: "divider",
          "&.Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
          "&:hover": {
            backgroundColor: "action.hover",
          },
        },
      }}
    >
      <ToggleButton value="list" aria-label="List view">
        <Tooltip title="List view">
          <ViewListIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="icons" aria-label="Icon view">
        <Tooltip title="Icon view">
          <GridViewIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewToggle;
